export default __webpack_public_path__ + "static/media/SPORTS_RECREATION.c55b7876.png";